'use client';

import { cn } from '@/lib/utils';
import { useEffect, useRef, useState } from 'react';
import Accordion, { IAccordion } from './Accordion';

export default function AccordionsBlock({
    accordions,
    white = false,
}: {
    accordions: IAccordion[];
    white?: boolean;
}) {
    const accordionRefs = useRef<Array<HTMLDivElement | null>>([]);
    const sectionRef = useRef<HTMLDivElement | null>(null);
    const [maxSectionHeight, setMaxSectionHeight] = useState(0);
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleAccordion = (index: number) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    useEffect(() => {
        if (sectionRef.current) {
            const contentHeights = accordionRefs.current.map((ref) => ref?.scrollHeight || 0);
            const largestContentHeight = Math.max(...contentHeights);

            const sectionHeight = sectionRef.current.scrollHeight;

            setMaxSectionHeight(sectionHeight + largestContentHeight);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accordions, sectionRef.current]);

    return (
        <div
            ref={sectionRef}
            style={{ height: maxSectionHeight, marginTop: maxSectionHeight ? 'auto' : 0 }}
        >
            {accordions.map(({ title, text }, index) => (
                <Accordion
                    ref={(el) => {
                        accordionRefs.current[index] = el;
                    }}
                    className={cn('mt-5 lg:mt-9', white && 'text-white border-white')}
                    title={title}
                    text={text}
                    index={index}
                    key={index}
                    isOpen={openIndex === index}
                    toggleAccordion={toggleAccordion}
                />
            ))}
        </div>
    );
}
